import type { DateValidationError } from '@mui/x-date-pickers';
import { useCallback, useRef, useState } from 'react';

export type UseDeferredDateFieldInvalidityResult = {
  handleError: (reason: DateValidationError | null) => void;
  handleChangeValidation: (validationError: DateValidationError | null) => void;
  handleBlur: () => void;
  errorReason: DateValidationError | null;
};

export function useDeferredDateFieldInvalidity(
  reportInvalid: (isInvalid: boolean) => void
): UseDeferredDateFieldInvalidityResult {
  const errorReasonRef = useRef<DateValidationError | null>(null);
  const [errorReason, setErrorReason] = useState<DateValidationError | null>(null);

  const handleError = useCallback((reason: DateValidationError | null) => {
    errorReasonRef.current = reason;
    setErrorReason(reason);
  }, []);

  const handleChangeValidation = useCallback(
    (validationError: DateValidationError | null) => {
      errorReasonRef.current = validationError;
      setErrorReason(validationError);
      reportInvalid(!!validationError);
    },
    [reportInvalid]
  );

  const handleBlur = useCallback(() => {
    if (errorReasonRef.current) {
      reportInvalid(true);
    }
  }, [reportInvalid]);

  return { handleError, handleChangeValidation, handleBlur, errorReason };
}
